export default {
  desktopWidth: 1920,
  galaxyS5Height: 640,
  iPad: 768,
  iPadPro: 1024,
  iphone6Height: 667,
  largerThanMobileWidth: 768,
  loginCardWidth: 744,
  maxTileWidth: 1352,
  mobileWidth: 767,
  smallerThanLoginCardWidth: 743,
  smallerThanVennSetWidth: 899,
  tablet: 800,
  vennSetWidth: 900
}
